import React, { Component } from "react";
import SlideEvents1 from "../layout/SlideEvents1";

class Section3AcademyMobile extends Component {
  render() {
    return (
      <div
        id="Section3Academy"
        className="section content_container"
        style={{
          width: this.props.wd.ww,
        }}
      >
        <div id="section2_anchor" className="column left section_dif_mobile">
          <div className="content">
            <img
              alt="Imagem do Título Graduação"
              className="title"
              src="images/section3academy_righttitle.png"
            />
            <p>
              Horus BJJ foi um mini campeonato realizado, não há muito tempo,
              pelo professor Nelson Lopes. Produzido nas instalações dos
              Bombeiros de Alcabideche, foi pequeno e familiar mas foi um
              sucesso! Mais um dia bem passado em equipa.
            </p>
          </div>
        </div>
        <div className="column right" style={{ height: this.props.wd.sh }}>
          <SlideEvents1 openVideoModal={this.props.openVideoModal} />
        </div>
      </div>
    );
  }
}

export default Section3AcademyMobile;
